import styled, { css } from 'styled-components'

import mediaQueries from 'components/media-queries'
import e2eClasses from 'helpers/automation'

export const SubmitButtonContainer = styled.div`
  flex: 0.32;
  margin-bottom: 40px;
  ${mediaQueries.mobile`
    flex: 1;
  `}
`

const commonBlocksMargin = css`
  margin-bottom: 32px;
`

export const RadioGroupContainer = styled.div`
  margin-bottom: 20px;

  ${mediaQueries.mobile`
    margin: 0;
  `}
`

export const SectionContainer = styled.div`
  ${commonBlocksMargin}
  ${({ noMargin }) => noMargin && `margin: 0;`} 
  ${({ theme, isLast }) =>
    !isLast &&
    `
    border-bottom: ${`0.5px dashed ${theme.colors.blue}`};
  `}
`
export const FormInformation = styled.p.attrs(() => ({
  className: e2eClasses('corporate.agreementsFormInformationText')
}))`
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.grayScorpion};
  font-size: 16px;
  text-align: justify;
  line-height: 22px;
  ${commonBlocksMargin};
`
export const StyledForm = styled.form.attrs(() => ({
  className: e2eClasses('corporate.agreementsFormInformationBox')
}))`
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  width: 100%;
  ${mediaQueries.mobile`
    width: 95%;
  `}
`
export const TitleWrapper = styled.div.attrs(props => ({
  className: props.e2eClass && `${e2eClasses('common.sectionTitle')}${props.e2eClass}`
}))`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 16px;
`

export const RowActionText = styled.span.attrs(props => ({
  className: props.e2eClass && `${e2eClasses('common.link')}${props.e2eClass}`
}))`
  color: ${({ theme }) => theme.colors.blue};
  user-select: none;
  letter-spacing: 0.3px;
  padding-left: 5px;
`

export const RowActionWrapper = styled.button`
  display: flex;
  align-items: center;
  max-width: fit-content;
  height: 50px;
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: 16px;
  &:hover {
    & ${RowActionText} {
      text-decoration: underline;
      text-decoration-color: ${({ theme }) => theme.colors.blue};
      cursor: pointer;
    }
  }
  ${mediaQueries.tablet`
    margin-bottom: 0;
  `}
  ${mediaQueries.mobile`
    margin: 10px 0;
  `}
`

export const IconWrapper = styled.div`
  display: flex;
`

export const InputDecorator = styled.span.attrs(() => ({
  className: e2eClasses('corporate.currentText')
}))`
  font-family: ${({ theme }) => theme.fonts.bold};
  font-size: 16px;
  letter-spacing: 0.3px;
  color: ${({ theme }) => theme.colors.blue};
`

export const SectionTitle = styled.h3`
  font-size: ${({ fontSize }) => fontSize || 18}px;
  color: ${({ theme }) => theme.colors.blue};
  ${({ noPadding }) => !noPadding && `padding-left: 16px;`}
  ${({ fontWeight }) =>
    fontWeight &&
    `
      font-weight: ${fontWeight};
  `}
`
export const InputRow = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 18px;
  align-items: flex-start;
  ${({ isLast }) =>
    isLast &&
    `
    margin-bottom: 32px;
  `}
`

export const DropdownContainer = styled.div`
  flex: 1;
  .react-select__control {
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: 3px;
    border: solid 1px ${({ theme }) => theme.colors.grayLight};
    font-family: ${({ theme }) => theme.fonts.regular};
    font-size: 14px;
    cursor: pointer;
    padding: ${({ small }) => (small ? '0' : '5px')};
    &:active {
      border: none;
      border: solid 1px ${({ theme }) => theme.colors.blue};
      box-shadow: 0 2px 10px 0 ${({ theme }) => theme.shadow.black26},
        0 2px 5px 0 ${({ theme }) => theme.shadow.black06};
    }

    ${({ error }) =>
      error &&
      css`
        border: solid 1px ${({ theme }) => theme.colors.red};
      `};
  }
  .react-select__value-container {
    /*Need max-width instead of width here due to firefox issue.*/
    max-width: 90%;

    ${mediaQueries.tablet`
      max-width: 80%;
    `};

    .react-select__single-value {
      color: ${({ theme }) => theme.colors.blue};
      font-family: ${({ theme }) => theme.fonts.semiBold};
    }
  }
  .react-select__indicators {
    transition: all 0.2s ease;
    .react-select__indicator-separator {
      display: none;
    }
  }

  .react-select__clear-indicator {
    display: none;
  }

  .react-select__control--is-focused {
    border: solid 1px ${({ theme }) => theme.colors.blue};
    box-shadow: 0 2px 10px 0 ${({ theme }) => theme.shadow.black26},
      0 2px 5px 0 ${({ theme }) => theme.shadow.black06};
    input:focus {
      box-shadow: none;
    }
    .react-select__indicators {
      .react-select__dropdown-indicator {
        transform: rotate(180deg);
      }
    }
  }
  .react-select__menu {
    margin-top: 1px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    .react-select__menu-list {
      max-height: 250px;
      padding: 0;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border: solid 1px ${({ theme }) => theme.colors.blue};
      border-top: 1px solid transparent;
      color: ${({ theme }) => theme.colors.dustyGray};
      font-family: ${({ theme }) => theme.fonts.regular};
      .react-select__option--is-selected {
        background-color: ${({ theme }) => theme.colors.transparent};
        font-family: ${({ theme }) => theme.fonts.semiBold};
        color: ${({ theme }) => theme.colors.blue};
      }
      .react-select__option--is-focused {
        cursor: pointer;
        color: ${({ theme }) => theme.colors.blueDark};
        font-family: ${({ theme }) => theme.fonts.semiBold};
        background-color: ${({ theme }) => theme.colors.blueLighter};
        color: ${({ theme }) => theme.colors.blueDark};
      }
    }
  }
  .react-select__control--is-disabled {
    background-color: ${({ theme }) => theme.colors.grayLighter};
  }
`

export const CheckboxContainer = styled.div`
  label {
    display: flex;
    align-items: flex-start;

    div {
      display: flex; /* Fix svg align*/
    }
  }
`

export const FeedbackContainer = styled.div`
  display: flex;
  ${({ noMargin }) => !noMargin && `margin-bottom: 32px;`}
`
export const FeedbackTitle = styled.span`
  font-family: ${({ theme }) => theme.fonts.bold};
  ${({ margin }) => margin && `margin: ${margin};`}
`

export const FormContainer = styled.div`
  ${mediaQueries.tablet`
    width: auto;
    padding-left: 10px;
    padding-right: 10px;
  `}

  ${mediaQueries.mobile`
    width: auto;
    padding-left: 10px;
    padding-right: 10px;
  `}
`

export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 16px;
  padding: 0 10px;
`

export const LabelGray = styled.label.attrs(props => ({
  className: props.e2eClass && `${e2eClasses('common.label')}${props.e2eClass}`
}))`
  color: ${({ theme }) => theme.colors.darkGrey};
  margin-top: 7px;
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: 14px;
`

export const SeparatorVertical = styled.div`
  height: 5px;
`
export const Link = styled.a`
  color: ${({ theme }) => theme.colors.blue};
  font-family: ${({ theme }) => theme.fonts.regular};
  text-decoration: underline;
  cursor: pointer;
  ${({ width }) => width && `width: ${width};`}
  ${({ flex }) => flex && `display: ${flex};`}
  ${({ alignItems }) => alignItems && `align-items: ${alignItems};`}
  ${({ justifyContent }) => justifyContent && `justify-content: ${justifyContent};`}
`

export const LabelInformation = styled.label`
  color: ${({ theme }) => theme.colors.doveGray};
  font-family: ${({ theme }) => theme.fonts.regular};
  line-height: 22px;
`

export const ParagraphInformation = styled.p`
  font-size: 14px;
  text-align: justify;
  line-height: 17.6px;
`

export const BoldText = styled.b``

export const Separator = styled.div`
  height: 15px;
`
export const RefundInformationContainer = styled.div`
  margin-bottom: 48px;
`

export const ResultWrapper = styled.div`
  padding: 50px 0;
`
export const Form = styled.form`
  width: 100%;
  max-width: 1200px;
  margin: 60px auto;
`

export const MiddleDashSeparator = styled.span`
  font-weight: bold;
`

export const CuitContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`
export const ExtraInformation = styled.div`
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.grayScorpion};
  margin-bottom: 50px;
  margin-top: -50px;

  ${mediaQueries.mobile`
  margin-top: -25px;
  font-size: 14px;
  `}

  li {
    list-style-type: none;

    &::before {
      content: '\\2022';
      color: ${({ theme }) => theme.colors.blue};
      font-size: 25px;
      font-weight: bold;
      display: inline-block;
      width: 20px;
      list-style-position: inside;
      align-content: center;
    }
  }

  &:empty {
    all: unset;
  }
`
export const InformationWarning = styled.div`
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.grayScorpion};
  ${mediaQueries.mobile`
  font-size: 14px;
  `}
`
export const RefundResultWrapper = styled.div`
  padding: 150px 0;
`
